import cx from 'classnames'
import {
  defaultImage,
  displayS3File,
} from '../../../../../../../client/src/utils/s3'
import { CampaignIncentive } from '../../../../../lib/api/types'

type IncentiveCardProps = {
  campaignIncentive: CampaignIncentive | null
  selected: boolean
  onSelect: (id: string) => void
}

export default function IncentiveCard({
  campaignIncentive,
  selected,
  onSelect,
}: IncentiveCardProps) {
  if (!campaignIncentive) return null

  const imageSrc = campaignIncentive.incentiveItem.picture
    ? displayS3File(campaignIncentive.incentiveItem.picture)
    : defaultImage


  return (
    <>
      <button
        disabled={!campaignIncentive.incentiveItem.isAvailable}
        onClick={() => onSelect(campaignIncentive.id)}
        className={cx(
          'w-full overflow-hidden transition-all duration-200 rounded-lg',
          'flex flex-col cursor-pointer',
          selected
            ? 'border-2 border-primary bg-primary text-primary-foreground'
            : 'border-2 border-base-input bg-background-light text-slate-50',
          !campaignIncentive.incentiveItem.isAvailable &&
          'opacity-50 cursor-not-allowed',
        )}
      >
        {/* Image Container */}
        <div className="relative w-full group overflow-hidden aspect-[2/1]">
          <img
            className="w-full h-full object-cover"
            src={imageSrc}
            alt={campaignIncentive.incentiveItem.name}
          />
        </div>

        {/* Text Container */}
        <div className="p-4 md:p-6 text-center">
          <p className="md:text-lg font-medium">
            {campaignIncentive.incentiveItem.name}
          </p>
        </div>
      </button>
    </>
  )
}
